const FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Default weekly timings (structured). days: 0=Sun … 6=Sat, times "HH:MM" 24h IST
export const DEFAULT_TIMINGS = [
  { days: [1, 2, 3, 4, 5], start: "12:30", end: "14:00", note: "Morning consultation" },
  { days: [1, 3, 5], start: "17:30", end: "19:30", note: "Evening consultation" },
  { days: [2, 4], start: "18:30", end: "19:30", note: "Evening consultation" },
  { days: [6], start: "11:00", end: "14:00", note: "" },
  { days: [0], start: "11:00", end: "13:00", note: "" },
];

export function toMinutes(hhmm) {
  const [h, m] = (hhmm || "0:0").split(":").map(Number);
  return h * 60 + m;
}

export function fmtTime(mins) {
  const h = Math.floor(mins / 60), m = mins % 60;
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}

export function dayLabel(days) {
  const d = [...new Set(days)].sort((a, b) => a - b);
  if (d.length === 0) return "—";
  if (d.length === 1) return FULL[d[0]];
  // Mon..Sun ordering for consecutive check (treat Sunday as 7)
  const ord = d.map((x) => (x === 0 ? 7 : x)).sort((a, b) => a - b);
  const consecutive = ord.every((x, i) => i === 0 || x === ord[i - 1] + 1);
  if (consecutive && d.length > 2) return `${FULL[ord[0] % 7]} – ${FULL[ord[ord.length - 1] % 7]}`;
  return ord.map((x) => SHORT[x % 7]).join(", ");
}

// Display rows: [{day, time, note}]
export function toDisplay(timings) {
  return (timings || []).filter((t) => t.days?.length && t.start && t.end).map((t) => ({
    day: dayLabel(t.days),
    time: `${fmtTime(toMinutes(t.start))} – ${fmtTime(toMinutes(t.end))}`,
    note: t.note || "",
  }));
}

// Schedule: {0:[[s,e]],…} minutes
export function toSchedule(timings) {
  const s = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
  for (const t of timings || []) {
    if (!t.start || !t.end) continue;
    for (const d of t.days || []) s[d].push([toMinutes(t.start), toMinutes(t.end)]);
  }
  for (const k in s) s[k].sort((a, b) => a[0] - b[0]);
  return s;
}
